module.exports = __webpack_public_path__ + "img/share.29b07ef.png";